var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.66634H11.1666V4.99967C11.1666 2.69967 9.29998 0.833008 6.99998 0.833008C4.69998 0.833008 2.83331 2.69967 2.83331 4.99967V6.66634H1.99998C1.08331 6.66634 0.333313 7.41634 0.333313 8.33301V16.6663C0.333313 17.583 1.08331 18.333 1.99998 18.333H12C12.9166 18.333 13.6666 17.583 13.6666 16.6663V8.33301C13.6666 7.41634 12.9166 6.66634 12 6.66634ZM6.99998 14.1663C6.08331 14.1663 5.33331 13.4163 5.33331 12.4997C5.33331 11.583 6.08331 10.833 6.99998 10.833C7.91665 10.833 8.66665 11.583 8.66665 12.4997C8.66665 13.4163 7.91665 14.1663 6.99998 14.1663ZM4.49998 6.66634V4.99967C4.49998 3.61634 5.61665 2.49967 6.99998 2.49967C8.38331 2.49967 9.49998 3.61634 9.49998 4.99967V6.66634H4.49998Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.8ce44930493f9bbc1c4a8e589ead4dd9.svg";
export { ForwardRef as ReactComponent };